export default {
  dontShowAgain2: false,
};
